import React from "react";
import { Tab, TabContent, TabSwitcher } from "../../tabs/Tab";
import { Rtefuente } from "../Rtefuente";
import { Rteica } from "../Rteica";
import { Rteiva } from "../Rteiva";

const Index = () => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="row my-2">
          <div className="col-sm-6">
            <h1 className="m-0">Certificaciones</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item active">Certificaciones</li>
            </ol>
          </div>
        </div>

        <Tab>
          <div>
            <TabSwitcher tabId={1}>
              <span className="p-2">RTE FUENTE</span>
              {/*add pading class*/}
            </TabSwitcher>
            <TabSwitcher tabId={2}>
              <span className="p-2">RTE ICA</span>
            </TabSwitcher>
            <TabSwitcher tabId={3}>
              <span className="p-2">RTE IVA</span>
            </TabSwitcher>
          </div>
          <div className="p-3 mt-2 bg-white border rounded">
            <TabContent id={1}>
              <Rtefuente />
            </TabContent>
            <TabContent id={2}>
              <Rteica />
            </TabContent>
             <TabContent id={3}>
              <Rteiva />
            </TabContent>
          </div>
        </Tab>
      </div>
    </div>
  );
};

export default Index;
